import { createSlice } from '@reduxjs/toolkit';

import socket from '../../utils/socket';

const initialState = {
  isLoading: false,
  error: false,
  // datas
  unavailabilities: [],
  unavailabilityTypes: []
};

const slice = createSlice({
  name: 'unavailabilities',
  initialState,
  reducers: {
    // LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      console.error(state.error);
    },

    getUnavailabilitiesTypes(state, action) {
      const { unavailabilitiesTypes } = action.payload;
      state.isLoading = false;
      state.unavailabilityTypes = unavailabilitiesTypes;
    }
  }
});

// Reducer
export default slice.reducer;

export function getUnavailabilitiesTypes() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const result = await socket.get('/unavailability/types');
      dispatch(slice.actions.getUnavailabilitiesTypes(result));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
